import * as Sentry from '@sentry/react';
import { App as AntApp, ConfigProvider } from 'antd';
import ReactDOM from 'react-dom/client';
import './index.css';
import { App } from './App';
import { getSentryConfig } from './config/sentry';

const sentryConfig = getSentryConfig();
if (sentryConfig) {
  Sentry.init({
    ...sentryConfig,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
        maskAllInputs: true,
      }),
    ],
  });
}

async function enableMocking() {
  if (import.meta.env.VITE_ENV !== 'test') {
    return false;
  }

  const { worker } = await import('./mocks/worker');
  await worker.start();
  return true;
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

enableMocking().then((mockingEnabled) => {
  if (mockingEnabled) {
    console.log('MSW enabled for testing');
  }
  root.render(
    <ConfigProvider modal={{ mask: { blur: false } }} drawer={{ mask: { blur: false } }}>
      <AntApp>
        <App />
      </AntApp>
    </ConfigProvider>
  );
});
